// Importar todas las traducciones en español
import common from './common';
import whoweare from './whoweare';
import opinionForm from './opinionForm';
import privacy from './privacy';
import subscribe from './subscribe';
import unsubscribe from './unsubscribe';
import sorteo from './sorteo';
import sorteoForm from './sorteoForm';

// Exportar todas las traducciones combinadas
const esTranslations = {
  translation: {
    ...common,
    ...whoweare,
    opinionForm,
    privacy,
    subscribe,
    unsubscribe,
    sorteo,
    sorteoForm
  }
};

export default esTranslations; 